import formManageModel from '../modules/form'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

const setFormDataAction = (formName, key, value) => {
  return async (dispatch, getState) => {
    const formData = get(getState().form, `${formName}`, {})
    dispatch(formManageModel.updateFormData({
      data: {
        [formName]: {...formData, [key]: value}
      }
    }))
  }
}

const updateFormDataAction = (formName, data) => {
  return async (dispatch, getState) => {
    dispatch (formManageModel.updateFormData({
      data: {
        [formName]: {...data}
      }
    }))
  }
}

const clearFormDataAction = (formName) => {
  return async (dispatch, getState) => {
    const form = getState().form
    if (!isEmpty(formName)) delete form[formName]

    dispatch(formManageModel.updateFormData({
      data: {...form}
    }))
  }
}

const setFormProcessAction = process => {
  return async dispatch => {
    dispatch(formManageModel.updateFormProcess({ process }))
  }
}

export {
  setFormDataAction,
  updateFormDataAction,
  clearFormDataAction,
  setFormProcessAction
}